import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle,
    Grid, Snackbar, Tooltip, Typography, TextField, Box, Hidden
    , FormControl, InputLabel, InputAdornment, Select, IconButton } from "@mui/material";
import { Search as IconSearch, IndeterminateCheckBox as IconIndeterminateCheckBox
    , CheckBox as IconCheckBox, PersonAdd as IconPersonAdd, AddCircle as IconAddCircle
    , Save as IconSave, LocalOffer as IconDescuento } from "@mui/icons-material";
import * as terapiaService from "../../services/terapiaService";
import * as periodoService from "../../services/periodoService";
import * as filialService from "../../services/filialService";
import * as catalogoService from "../../services/catalogoService";
import * as servicioService from "../../services/servicioService";
import * as seguridadService from "../../services/seguridadService";
import descuentoService from "../../services/descuentoService";
import descuentoCatalogoService from "../../services/descuentoCatalogoService";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { setValue, setListPeriodos, setListFilial, setListTiposTerapias, setListEstados } from '../../redux/therapyPeriodSearchSlice';
import { setAccesos } from '../../redux/seguridadSlice';
import DialogYesNo from '../../components/DialogYesNo';
import DataGridBase from "../../components/common/DataGridBase";
import DialogoBusqueda from "../../components/common/DialogoBusqueda";
import DialogoCredenciales from "../../components/DialogoCredenciales";
import { PaperComponentDraggable } from "../../components/common/PaperComponentDraggable";
import { useMantenimiento } from "../../hooks/useMantenimiento";

// Columnas de las ventanas de busqueda del mantenimiento del periodo.
const columnasTerapias = [
    { field: 'participante', headerName: 'Participante', width: 200, sortable: false, headerAlign: 'left' },
    { field: 'terapeuta', headerName: 'Terapeuta', width: 180, sortable: false, headerAlign: 'left' },
    { field: 'tipo', headerName: 'Tipo', width: 120, sortable: false, headerAlign: 'center', align: 'center' },
    { field: 'estado', headerName: 'Estado', width: 80, sortable: false, headerAlign: 'center', align: 'center' },
];

const columnasPeriodosForm = [
    { field: 'codigo', headerName: 'Codigo', width: 140, sortable: false, headerAlign: 'center', align: 'center' },
    { field: 'descripcion', headerName: 'Descripcion', width: 240, sortable: false, headerAlign: 'left' },
    { field: 'fechaInicio', headerName: 'Inicio', width: 120, type: 'date'
        , valueFormatter: (value) => moment(value).format('DD/MM/YYYY')
        , sortable: false, headerAlign: 'center', align: 'center' },
    { field: 'estado', headerName: 'Estado', width: 80, sortable: false, headerAlign: 'center', align: 'center' },
];

const Index = () => {
    const { isReadOnly, idFilial, perfilCargado } = useMantenimiento("terapiaPeriodo");
    const accesos = useSelector((state) => state.seguridad?.accesos) || [];
    const seguridadActiva = useSelector((state) => state.seguridad?.seguridadActiva) || "N";
    const puedeAbrir = seguridadActiva === "S"
        ? (accesos.includes("terapiaPeriodo.abrir") || accesos.includes("terapiaPeriodo.editar"))
        : true;
    const filters = useSelector((state) => state.therapyPeriodSearch.filters);
    const listPeriodos = useSelector((state) => state.therapyPeriodSearch.listPeriodos);
    const listFilial = useSelector((state) => state.therapyPeriodSearch.listFilial);
    const listTiposTerapias = useSelector((state) => state.therapyPeriodSearch.listTiposTerapias);
    const listEstados = useSelector((state) => state.therapyPeriodSearch.listEstados);

    const [openDialogAnnulActive, setOpenDialogAnnulActive] = useState(false);
    const openCloseDialogAnnulActive = () => { setOpenDialogAnnulActive(!openDialogAnnulActive); };
    const [selectId, setSelectId] = useState(null);
    const [selectState, setSelectState] = useState(null);

    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [openMessage, setOpenMessage] = useState(false);
    const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });

    const mensaje = (severity, texto) => {
        setPropsMessage({ severity: severity, message: texto });
        setOpenMessage(true);
    };

    // Mantenimiento del periodo de terapia (solo Administrador o Director):
    // se elige la terapia, el periodo y la tarifa con sus botones de busqueda
    // agrupados, y permite registrar descuento igual que en TerapiaParticipante.
    const [openMantenimiento, setOpenMantenimiento] = useState(false);
    const [periodoEditando, setPeriodoEditando] = useState(null);
    const [guardandoPeriodo, setGuardandoPeriodo] = useState(false);
    const [periodoForm, setPeriodoForm] = useState({
        idTerapiaPeriodo: 0,
        idTerapia: 0,
        idPeriodo: 0,
        numero: 1,
        idTarifa: 0,
        idDescuento: 0,
        montoDescuento: 0,
    });
    const [formTarifa, setFormTarifa] = useState("");
    const [tarifaMonto, setTarifaMonto] = useState(0);
    const [formCodigoDescuento, setFormCodigoDescuento] = useState("");
    const [listaTarifas, setListaTarifas] = useState([]);
    const [buscandoTarifa, setBuscandoTarifa] = useState(false);
    const [formTerapia, setFormTerapia] = useState("");
    const [formPeriodo, setFormPeriodo] = useState("");
    const [buscandoTerapia, setBuscandoTerapia] = useState(false);
    const [buscandoPeriodoForm, setBuscandoPeriodoForm] = useState(false);
    const [listaTerapias, setListaTerapias] = useState([]);
    const [listaPeriodosForm, setListaPeriodosForm] = useState([]);
    const [terapiaElegida, setTerapiaElegida] = useState(null);
    const [periodoElegidoForm, setPeriodoElegidoForm] = useState(null);

    // Estado para registrar descuento (mismo funcionamiento que en TherapyMember).
    const [listDescuentoCatalogo, setListDescuentoCatalogo] = useState([]);
    const [listTiposDescuento, setListTiposDescuento] = useState([]);
    const [dialogoCredencialesAbierto, setDialogoCredencialesAbierto] = useState(false);
    const [dialogoDescuentoAbierto, setDialogoDescuentoAbierto] = useState(false);
    const [tokenAprobacion, setTokenAprobacion] = useState("");
    const [formDescuento, setFormDescuento] = useState({
        idDescuentoCatalogo: 0,
        idTipoCalculo: 0,
        valor: 0,
        isPorcentaje: true,
        fechaInicio: moment(new Date()).format("YYYY-MM-DD"),
        fechaFin: moment(new Date()).add(1, "years").format("YYYY-MM-DD"),
        idEstado: 2,
    });

    const abrirMantenimientoPeriodo = (row) => {
        if (isReadOnly) return;

        setPeriodoEditando(row);

        if (row) {
            setPeriodoForm({
                idTerapiaPeriodo: row.id || 0,
                idTerapia: row.idTerapia || 0,
                idPeriodo: row.idPeriodo || 0,
                numero: row.numero || 1,
                idTarifa: row.idTarifa || 0,
                idDescuento: row.idDescuento || 0,
                montoDescuento: parseFloat(row.montoDescuento) || 0,
            });
            setFormTerapia(row.participante ? (row.participante + (row.terapeuta ? " - " + row.terapeuta : "")) : "");
            setFormPeriodo(row.codigoPeriodo || "");
            setFormTarifa(row.concepto || "");
            setTarifaMonto(parseFloat(row.montoTarifa) || 0);
            setFormCodigoDescuento(row.codigoDescuento || "");
            if (row.idDescuento && row.idDescuento > 0 && !row.codigoDescuento) {
                descuentoService.getDescuento(row.idDescuento).then((d) => {
                    const dd = d && d.data ? (d.data.data || d.data) : null;
                    if (dd) {
                        const cod = dd.codigo || dd.Codigo || "";
                        const desc = dd.descripcion || dd.Descripcion || "";
                        setFormCodigoDescuento(cod && desc ? `${cod} - ${desc}` : (cod || desc));
                    }
                }).catch(() => {});
            }
            setTerapiaElegida({
                idTerapia: row.idTerapia,
                id: row.idTerapia,
                idPersona: row.idPersona || 0,
                idTarifa: row.idTarifa || 0,
                participante: row.participante,
                terapeuta: row.terapeuta,
            });
            setPeriodoElegidoForm(row.idPeriodo ? { id: row.idPeriodo, codigo: row.codigoPeriodo } : null);
        } else {
            setPeriodoForm({ idTerapiaPeriodo: 0, idTerapia: 0, idPeriodo: 0, numero: 1, idTarifa: 0, idDescuento: 0, montoDescuento: 0 });
            setFormTerapia("");
            setFormPeriodo("");
            setFormTarifa("");
            setTarifaMonto(0);
            setFormCodigoDescuento("");
            setTerapiaElegida(null);
            setPeriodoElegidoForm(null);
        }

        setOpenMantenimiento(true);
    };

    // Al abrir la lupa se listan las terapias activas.
    const abrirBuscaTerapia = async () => {
        setBuscandoTerapia(true);
        setTerapiaElegida(null);

        const data = await terapiaService.getsTerapiasActivas()
            .catch((err) => { console.log("Err: ", err); return []; });

        setListaTerapias(data || []);
    };

    const elegirTerapia = async (terapia) => {
        setTerapiaElegida(terapia);
        setFormTerapia(terapia.participante + (terapia.terapeuta ? " - " + terapia.terapeuta : ""));
        const idTarifaTerapia = terapia.idTarifa || 0;
        setPeriodoForm((prev) => ({
            ...prev,
            idTerapia: terapia.idTerapia || terapia.id,
            idTarifa: idTarifaTerapia || prev.idTarifa,
        }));
        if (idTarifaTerapia > 0) {
            const tarifas = await servicioService.getsConceptoCobroView({ idServicio: 0, idFilial: 0, idTipo: 0, sesionesMes: 0, idEstado: 2 })
                .catch(() => []);
            const tSel = (tarifas || []).find((t) => (t.idConceptoCobro || t.id) === idTarifaTerapia);
            if (tSel) {
                setFormTarifa(tSel.descripcion || tSel.Descripcion || "");
                setTarifaMonto(parseFloat(tSel.monto || tSel.Monto) || 0);
            }
        }
        setBuscandoTerapia(false);
    };

    const abrirBuscaPeriodo = async () => {
        setBuscandoPeriodoForm(true);
        setPeriodoElegidoForm(null);

        const data = await periodoService.getsPeriodoView({
            idFilial: 0, idTipoTerapia: 0, idEstadoApertura: 0, mesesHaciaAtras: 0, idEstado: 2,
        }).catch((err) => { console.log("Err: ", err); return []; });

        setListaPeriodosForm(data || []);
    };

    const elegirPeriodoForm = (periodo) => {
        setPeriodoElegidoForm(periodo);
        setFormPeriodo(periodo.codigo);
        setPeriodoForm((prev) => ({ ...prev, idPeriodo: periodo.id }));
        setBuscandoPeriodoForm(false);
    };

    // Busqueda de tarifa (concepto de cobro) para el periodo.
    const abrirBuscaTarifa = async () => {
        setBuscandoTarifa(true);
        setListaTarifas([]);
        const data = await servicioService.getsConceptoCobroView({ idServicio: 0, idFilial: 0, idTipo: 0, sesionesMes: 0, idEstado: 2 })
            .catch((err) => { console.log("Err: ", err); return []; });
        setListaTarifas(data || []);
    };

    const elegirTarifa = (tarifa) => {
        const nuevoMontoTarifa = parseFloat(tarifa.monto || tarifa.Monto) || 0;
        setPeriodoForm((prev) => ({ ...prev, idTarifa: tarifa.idConceptoCobro || tarifa.id || 0 }));
        setFormTarifa(tarifa.descripcion || tarifa.Descripcion || "");
        setTarifaMonto(nuevoMontoTarifa);
        setBuscandoTarifa(false);
    };

    // Registro de descuento (mismo comportamiento que en TherapyMember).
    const abrirRegistroDescuento = () => {
        if (periodoForm.idDescuento && periodoForm.idDescuento > 0) {
            mensaje("warning", "Los descuentos no se pueden modificar (" + (formCodigoDescuento || "") + "), solo registrar o anular.");
            return;
        }
        const hoy = moment(new Date()).format("YYYY-MM-DD");
        const unAnio = moment(new Date()).add(1, "years").format("YYYY-MM-DD");
        setFormDescuento({
            idDescuentoCatalogo: 0,
            idTipoCalculo: 0,
            valor: 0,
            isPorcentaje: true,
            fechaInicio: hoy,
            fechaFin: unAnio,
            idEstado: 2,
        });
        setDialogoCredencialesAbierto(true);
    };

    const credencialesConfirmadas = (aprobacion) => {
        setDialogoCredencialesAbierto(false);
        setTokenAprobacion(aprobacion && aprobacion.token ? aprobacion.token : "");
        setDialogoDescuentoAbierto(true);
    };

    const registrarDescuento = async () => {
        if (!formDescuento.idDescuentoCatalogo || formDescuento.idDescuentoCatalogo == 0) {
            mensaje("error", "Falta seleccionar el Descuento del catalogo");
            return;
        }
        if (!formDescuento.idTipoCalculo || formDescuento.idTipoCalculo == 0) {
            mensaje("error", "Falta seleccionar el Tipo de Calculo");
            return;
        }
        if (!formDescuento.valor || parseFloat(formDescuento.valor) <= 0) {
            mensaje("error", "El valor del descuento debe ser mayor a 0");
            return;
        }

        const baseMontoCalc = parseFloat(tarifaMonto) || 0;
        const valorNumCalc = parseFloat(formDescuento.valor) || 0;
        const tipoSelCalc = (listTiposDescuento || []).find((t) => t.id == formDescuento.idTipoCalculo);
        const descTipoCalc = (tipoSelCalc && tipoSelCalc.descripcion ? tipoSelCalc.descripcion : "").toLowerCase();
        const esPorcCalc = descTipoCalc.includes("porcentaje") || descTipoCalc.includes("%");
        const montoEstimado = esPorcCalc ? ((baseMontoCalc * valorNumCalc) / 100) : valorNumCalc;

        if (baseMontoCalc > 0 && montoEstimado > baseMontoCalc) {
            mensaje("error", "El monto del descuento (" + montoEstimado.toFixed(2) + ") no puede ser mayor al monto de la tarifa (" + baseMontoCalc.toFixed(2) + ").");
            return;
        }

        const dataPost = {
            id: 0,
            idDescuentoCatalogo: parseInt(formDescuento.idDescuentoCatalogo),
            idTipoCalculo: parseInt(formDescuento.idTipoCalculo),
            valor: parseFloat(formDescuento.valor),
            fechaInicio: formDescuento.fechaInicio,
            fechaFin: formDescuento.fechaFin,
            idEstado: parseInt(formDescuento.idEstado),
        };

        const response = await descuentoService.addUpdateDescuento(dataPost, tokenAprobacion)
            .catch((err) => {
                console.log("Err: ", err);
                const msg = err?.response?.data?.Detail
                    || err?.response?.data?.detail
                    || "No se pudo registrar el descuento";
                mensaje("error", msg);
                return null;
            });

        if (!response || !response.data) return;

        const nuevoId = response.data.data;
        const catSel = (listDescuentoCatalogo || []).find((c) => c.id == formDescuento.idDescuentoCatalogo);
        const tipoSel = (listTiposDescuento || []).find((t) => t.id == formDescuento.idTipoCalculo);
        const descTipo = (tipoSel && tipoSel.descripcion ? tipoSel.descripcion : "").toLowerCase();
        const esPorcentaje = descTipo.includes("porcentaje") || descTipo.includes("%");
        const valorNum = parseFloat(formDescuento.valor) || 0;
        const baseMonto = parseFloat(tarifaMonto) || 0;
        const monto = esPorcentaje
            ? Number(((baseMonto * valorNum) / 100).toFixed(2))
            : Number(valorNum.toFixed(2));

        setPeriodoForm((prev) => ({
            ...prev,
            idDescuento: nuevoId,
            montoDescuento: monto,
        }));
        setFormCodigoDescuento(catSel ? (catSel.codigo + " - " + catSel.descripcion) : "");
        setDialogoDescuentoAbierto(false);
        mensaje("success", "Descuento registrado y asignado al periodo de terapia");
    };

    // Registra o modifica el periodo de terapia.
    const guardarPeriodo = async () => {
        if (isReadOnly) return;

        if (tarifaMonto > 0 && periodoForm.montoDescuento > tarifaMonto) {
            mensaje("error", "El monto del descuento (" + (parseFloat(periodoForm.montoDescuento) || 0).toFixed(2) + ") no puede ser mayor al monto de la tarifa (" + (parseFloat(tarifaMonto) || 0).toFixed(2) + ").");
            return;
        }

        if (periodoForm.idTerapia <= 0) {
            mensaje("error", "Elija la terapia del periodo.");
            return;
        }

        if (periodoForm.idPeriodo <= 0) {
            mensaje("error", "Elija el periodo.");
            return;
        }

        setGuardandoPeriodo(true);

        const esEdicion = !!(periodoEditando && periodoForm.idTerapiaPeriodo > 0);

        await terapiaService.addTerapiaPeriodo(
            periodoForm.idPeriodo,
            periodoForm.idTerapia,
            periodoForm.numero,
            periodoForm.idTarifa,
            terapiaElegida ? (terapiaElegida.idPersona || 0) : (periodoEditando ? (periodoEditando.idPersona || 0) : 0),
            formPeriodo,
            formTerapia,
            periodoForm.idDescuento > 0 ? periodoForm.idDescuento : null,
            periodoForm.montoDescuento > 0 ? periodoForm.montoDescuento : null,
            periodoForm.idTerapiaPeriodo || 0
        )
            .then((response) => {
                setGuardandoPeriodo(false);
                setOpenMantenimiento(false);

                const data = response && response.data ? response.data.data : null;

                if (!data || !data.idTerapiaPeriodo || data.idTerapiaPeriodo <= 0) {
                    mensaje("error", "No se pudo guardar el periodo de terapia.");
                    return;
                }

                fetchResults();

                if (data.existia) {
                    mensaje("warning", "El periodo de terapia ya estaba registrado para esa terapia y periodo. No se registro de nuevo.");
                    return;
                }

                mensaje("success", esEdicion
                    ? "Se actualizo el periodo de terapia."
                    : "Se registro el periodo de terapia.");
            })
            .catch((err) => {
                setGuardandoPeriodo(false);
                console.log("Err: ", err);
                mensaje("error", "No se pudo guardar el periodo de terapia.");
            });
    };

    const fetchResults = async (filtros = filters) => {
        setCargando(true);

        await terapiaService.getsTerapiaPeriodoResumenView(filtros)
            .then((data) => {
                setResults(data);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
    };

    const fetchPeriodos = async () => {
        await periodoService.getsPeriodoView({
                idTipoTerapia: 0,
                idEstadoApertura: 87,
                mesesHaciaAtras: 0,
                idEstado: 2,
            })
            .then((data) => {
                dispatch(setListPeriodos(data));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
    };

    const fetchListFilial = async () => {
        await filialService.getFilialesList()
            .then((data) => {
                // Si el usuario tiene filial asignada, su filtro solo ofrece esa.
                dispatch(setListFilial(filialService.soloFilialDelUsuario(data, idFilial)));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
    };

    const fetchTiposTerapias = async () => {
        await catalogoService.getCatalogosByPadre(49)
            .then((data) => {
                dispatch(setListTiposTerapias(data));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
    };

    const fetchEstados = async () => {
        await catalogoService.getCatalogosByPadre(1)
            .then((data) => {
                dispatch(setListEstados(data));
                dispatch(setValue({ name: "idEstado", value: 2 }));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
    };

    const fetchCatalogosDescuento = async () => {
        descuentoCatalogoService.getsDescuentoCatalogoActivos()
            .then((res) => {
                if (res && res.data && res.data.data) setListDescuentoCatalogo(res.data.data);
            })
            .catch((err) => { console.log("Err: ", err); });
        catalogoService.getCatalogosByPadre(315)
            .then((data) => { setListTiposDescuento(data || []); })
            .catch((err) => { console.log("Err: ", err); });
    };

    const annulTerapiaPeriodo = async () => {
        await terapiaService.annulTerapiaPeriodo(selectId)
            .then(() => {
                mensaje("success", "Periodo de terapia anulado.");
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
                const msg = err?.response?.data?.detail || err?.response?.data?.Detail || "No se pudo anular el periodo de terapia.";
                mensaje("warning", msg);
            });
        fetchResults();
    };

    const activeTerapiaPeriodo = async () => {
        return;
    };

    useEffect(() => {
        const usuario = sessionStorage.getItem("sisdet.usuario");
        if (usuario) {
            seguridadService.getsAccesosUsuario(usuario)
                .then((lista) => dispatch(setAccesos(lista || [])))
                .catch(() => {});
        }
        fetchPeriodos();
        fetchTiposTerapias();
        fetchEstados();
        fetchCatalogosDescuento();
    }, []);

    // El filtro de filial se arma cuando llega el perfil del usuario: si se
    // armara antes, se verian todas las sedes. Con una filial asignada el
    // filtro queda fijo en esa y el listado sale ya acotado.
    useEffect(() => {
        if (!perfilCargado) return;

        fetchListFilial();

        if (idFilial > 0) {
            dispatch(setValue({ name: "idFilial", value: idFilial }));
            fetchResults({ ...filters, idFilial });
        }
        else {
            fetchResults();
        }
    }, [perfilCargado, idFilial]);

    const columns = [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        { field: 'codigoFilial', headerName: 'Filial', width: 70, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'participante', headerName: 'Participante', width: 180, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                const row = cellValues.row;
                if (isReadOnly) {
                    return row.participante;
                }
                return (
                    <Box sx={{ cursor: 'pointer', textDecoration: 'underline', color: 'primary.main' }} onClick={() => { abrirMantenimientoPeriodo(row); }}>
                        {row.participante}
                    </Box>
                );
            }
        },
        { field: 'terapeuta', headerName: 'Terapeuta', width: 180, sortable: false, headerAlign: 'center' },
        { field: 'codigoPeriodo', headerName: 'Periodo', width: 90, sortable: false, headerAlign: 'center', align: 'center' },
        {
            field: 'montoTotal',
            headerName: 'Monto',
            width: 100,
            sortable: false,
            headerAlign: 'right',
            align: 'right',
            renderCell: (cellValues) => {
                const row = cellValues.row;
                // El monto de la tarifa se muestra aunque no haya comprobante.
                const monto = (parseFloat(row.montoTotal) || 0) > 0 ? parseFloat(row.montoTotal) : (parseFloat(row.montoTarifa) || 0);
                return monto.toFixed(2);
            }
        },
        { field: 'montoDescuento', headerName: 'Descuento', width: 110, sortable: false, headerAlign: 'right', align: 'right'
            , valueFormatter: (value) => value == null ? "" : (parseFloat(value) || 0).toFixed(2) },
        // Saldo: suma de los saldos de los comprobantes asignados al terapiaperiodo.
        // Sin comprobante asignado, la celda queda vacia.
        {
            field: 'montoSaldo',
            headerName: 'Saldo',
            width: 100,
            sortable: false,
            headerAlign: 'right',
            align: 'right',
            renderCell: (cellValues) => {
                const row = cellValues.row;
                if (!row.idComprobante || row.idComprobante === 0) return "";
                return (parseFloat(row.montoSaldo) || 0).toFixed(2);
            }
        },
        { field: 'estado', headerName: 'Estado', width: 80, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'anular', headerName: '', width: 80, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                const row = cellValues.row;
                if (row.estado != "A") return "";
                const tieneComprobanteVigente = row.idComprobante > 0;
                return <IconButton aria-label="anular" size='small' style={{ height: 10 }} align={"center"} disabled={isReadOnly || tieneComprobanteVigente} onClick={() => {
                    setSelectId(row.id);
                    setSelectState(row.estado);
                    setOpenDialogAnnulActive(true);
                }}>
                    <IconIndeterminateCheckBox />
                </IconButton>;
            }
        },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Periodos de Terapia
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1} padding={0}>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-filial">Filial</InputLabel>
                                    <Select
                                        native
                                        label="Filial"
                                        value={filters.idFilial}
                                        disabled={idFilial > 0}
                                        onChange={(event) => {
                                            dispatch(setValue({ name: "idFilial", value: event.target.value }));
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idFilial',
                                            id: 'input-filial',
                                        }}
                                        size="small"
                                    >
                                        {idFilial <= 0 && <option key={0} value={0}>{"(Todos)"}</option>}
                                        {listFilial.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-periodo" shrink>Periodo</InputLabel>
                                    <Select
                                        native
                                        label="Periodo"
                                        value={filters.idPeriodo}
                                        onChange={(event) => {
                                            dispatch(setValue({ name: "idPeriodo", value: event.target.value }));
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idPeriodo',
                                            id: 'input-periodo',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listPeriodos.map((row) => (
                                            <option key={row.id} value={row.id}>{row.codigo}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-tipoterapia" shrink>Tipo Terapia</InputLabel>
                                    <Select
                                        native
                                        label="Tipo Terapia"
                                        value={filters.idTipoTerapia}
                                        onChange={(event) => {
                                            dispatch(setValue({ name: "idTipoTerapia", value: event.target.value }));
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idTipoTerapia',
                                            id: 'input-tipoterapia',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listTiposTerapias.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <TextField
                                    name="participante"
                                    label="Participante"
                                    value={filters.participante}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({ name: "participante", value: event.target.value }));
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <TextField
                                    name="terapeuta"
                                    label="Terapeuta"
                                    value={filters.terapeuta}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({ name: "terapeuta", value: event.target.value }));
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-estado" shrink>Estado</InputLabel>
                                    <Select
                                        native
                                        label="Estado"
                                        value={filters.idEstado}
                                        onChange={(event) => {
                                            dispatch(setValue({ name: "idEstado", value: event.target.value }));
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idEstado',
                                            id: 'input-estado',
                                        }}
                                        size="small"
                                    >
                                        {listEstados.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4} sm={1} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" size="medium" fullWidth onClick={() => {
                                    fetchResults();
                                }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                toolbarButtons={[
                                    {
                                        text: "Abrir",
                                        icon: <IconPersonAdd />,
                                        disabled: !puedeAbrir,
                                        onClick: () => navigate("/therapyPeriod/open")
                                    },
                                    {
                                        text: "Nuevo",
                                        icon: <IconAddCircle />,
                                        disabled: isReadOnly,
                                        onClick: () => { abrirMantenimientoPeriodo(null); }
                                    }
                                ]}
                            />
                        </Box>
                    </Grid>
                    <DialogYesNo open={openDialogAnnulActive} openClose={openCloseDialogAnnulActive} setYes={ selectState == "A" ? annulTerapiaPeriodo : activeTerapiaPeriodo} 
                        setNo={() => { return }}
                        titulo={(selectState == "A" ? "Anular" : "Activar") + " Periodo de Terapia"}
                        texto={"Esta seguro de " + (selectState == "A" ? "anular" : "activar") + " el periodo de la terapia?"} >
                    </DialogYesNo>

                    <Snackbar open={openMessage} autoHideDuration={6000} onClose={() => setOpenMessage(false)}
                        anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                        <Alert onClose={() => setOpenMessage(false)} severity={propsMessage.severity}>
                            {propsMessage.message}
                        </Alert>
                    </Snackbar>

                    {/* Mantenimiento del periodo de terapia (solo Administrador o Director).
                        Terapia, Periodo y Tarifa agrupados con sus botones buscar con icono;
                        Monto Tarifa, Cod. Descuento, Monto Descuento y boton Registrar Descuento. */}
                    <Dialog open={openMantenimiento} fullWidth maxWidth="sm" PaperComponent={PaperComponentDraggable}
                        onClose={() => setOpenMantenimiento(false)}>
                        <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
                            <Typography variant="h6" component="span" sx={{ fontWeight: 'bold' }}>
                                {(periodoEditando ? "Editar" : "Nuevo") + " Periodo de Terapia"}
                            </Typography>
                        </DialogTitle>
                        <DialogContent>
                            <Grid container spacing={1.5} alignItems={"center"} sx={{ paddingTop: "12px" }}>
                                <Grid item xs={12} sm={7}>
                                    <TextField
                                        name="formTerapia"
                                        label="Terapia"
                                        value={formTerapia}
                                        fullWidth
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly: true,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Tooltip title={"Buscar terapia"}>
                                                        <IconButton
                                                            aria-label="buscar terapia del periodo"
                                                            size="small"
                                                            edge="end"
                                                            onClick={abrirBuscaTerapia}
                                                        >
                                                            <IconSearch fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <TextField
                                        name="formPeriodo"
                                        label="Periodo"
                                        value={formPeriodo}
                                        fullWidth
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly: true,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Tooltip title={"Buscar periodo"}>
                                                        <IconButton
                                                            aria-label="buscar periodo del periodo"
                                                            size="small"
                                                            edge="end"
                                                            onClick={abrirBuscaPeriodo}
                                                        >
                                                            <IconSearch fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={7}>
                                    <TextField
                                        name="formTarifa"
                                        label="Tarifa"
                                        value={formTarifa}
                                        fullWidth
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly: true,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Tooltip title={"Buscar tarifa"}>
                                                        <IconButton
                                                            aria-label="buscar tarifa del periodo"
                                                            size="small"
                                                            edge="end"
                                                            onClick={abrirBuscaTarifa}
                                                        >
                                                            <IconSearch fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <TextField
                                        name="tarifaMonto"
                                        label="Monto Tarifa"
                                        value={(parseFloat(tarifaMonto) || 0).toFixed(2)}
                                        fullWidth
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{ readOnly: true }}
                                        inputProps={{ style: { textAlign: 'right' } }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        name="formCodigoDescuento"
                                        label="Cod. Descuento"
                                        value={formCodigoDescuento || ""}
                                        fullWidth
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid item xs={9} sm={4}>
                                    <TextField
                                        name="montoDescuento"
                                        label="Monto Descuento"
                                        value={(parseFloat(periodoForm.montoDescuento) || 0).toFixed(2)}
                                        fullWidth
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{ readOnly: true }}
                                        inputProps={{ style: { textAlign: 'right' } }}
                                    />
                                </Grid>
                                <Grid item xs={3} sm={2} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                                    <Tooltip title={"Registrar descuento"}>
                                        <span>
                                            <IconButton
                                                color="primary"
                                                aria-label="registrar descuento"
                                                onClick={abrirRegistroDescuento}
                                            >
                                                <IconDescuento />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="outlined" onClick={() => setOpenMantenimiento(false)}>{"Cancelar"}</Button>
                            <Button variant="contained" startIcon={<IconSave />} disabled={guardandoPeriodo || isReadOnly}
                                onClick={guardarPeriodo}>{"Guardar"}</Button>
                        </DialogActions>
                    </Dialog>

                    {/* Credenciales para aprobar el registro del descuento. */}
                    <DialogoCredenciales
                        abierto={dialogoCredencialesAbierto}
                        accion="descuento.registrar"
                        acceso="descuento.editar"
                        titulo="Aprobar registro de descuento"
                        mensaje="Quien aprueba debe tener acceso descuento.editar."
                        onCancelar={() => setDialogoCredencialesAbierto(false)}
                        onConfirmar={credencialesConfirmadas}
                    />

                    {/* Ventana para registrar el descuento (mismo funcionamiento que en TerapiaParticipante). */}
                    <Dialog open={dialogoDescuentoAbierto} onClose={() => setDialogoDescuentoAbierto(false)} maxWidth="sm" fullWidth PaperComponent={PaperComponentDraggable}>
                        <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>{"Registrar descuento"}</DialogTitle>
                        <DialogContent>
                            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="input-desc-cat-periodo">Descuento catalogo</InputLabel>
                                        <Select
                                            native
                                            label="Descuento catalogo"
                                            value={formDescuento.idDescuentoCatalogo}
                                            onChange={(e) => setFormDescuento({ ...formDescuento, idDescuentoCatalogo: parseInt(e.target.value) })}
                                            inputProps={{ name: 'idDescuentoCatalogo', id: 'input-desc-cat-periodo' }}
                                            size="small"
                                        >
                                            <option key={0} value={0}>{"Seleccione"}</option>
                                            {(listDescuentoCatalogo || []).map((row) => (
                                                <option key={row.id} value={row.id}>{row.codigo + " - " + row.descripcion}</option>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="input-tipo-calc-periodo">Tipo de calculo</InputLabel>
                                        <Select
                                            native
                                            label="Tipo de calculo"
                                            value={formDescuento.idTipoCalculo}
                                            onChange={(e) => {
                                                const idTipo = parseInt(e.target.value);
                                                const sel = (listTiposDescuento || []).find((t) => t.id == idTipo);
                                                const desc = sel && sel.descripcion ? sel.descripcion.toLowerCase() : "";
                                                const esPorc = desc.includes("porcentaje") || desc.includes("%");
                                                setFormDescuento({ ...formDescuento, idTipoCalculo: idTipo, isPorcentaje: esPorc });
                                            }}
                                            inputProps={{ name: 'idTipoCalculo', id: 'input-tipo-calc-periodo' }}
                                            size="small"
                                        >
                                            <option key={0} value={0}>{"Seleccione"}</option>
                                            {(listTiposDescuento || []).map((row) => (
                                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        type="number"
                                        name="valor"
                                        label={formDescuento.isPorcentaje ? "Valor (%)" : "Monto fijo"}
                                        value={formDescuento.valor}
                                        onChange={(e) => setFormDescuento({ ...formDescuento, valor: e.target.value })}
                                        fullWidth
                                        size="small"
                                        inputProps={{ step: "0.01", min: 0 }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        type="date"
                                        name="fechaInicio"
                                        label="Inicio"
                                        value={formDescuento.fechaInicio}
                                        onChange={(e) => setFormDescuento({ ...formDescuento, fechaInicio: e.target.value })}
                                        fullWidth
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        type="date"
                                        name="fechaFin"
                                        label="Fin"
                                        value={formDescuento.fechaFin}
                                        onChange={(e) => setFormDescuento({ ...formDescuento, fechaFin: e.target.value })}
                                        fullWidth
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setDialogoDescuentoAbierto(false)}>{"Cancelar"}</Button>
                            <Button variant="contained" onClick={registrarDescuento}>{"Guardar"}</Button>
                        </DialogActions>
                    </Dialog>

                    {/* Lupa de la terapia del periodo. */}
                    <DialogoBusqueda
                        open={buscandoTerapia}
                        onClose={() => setBuscandoTerapia(false)}
                        titulo="Buscar Terapia"
                        columns={columnasTerapias}
                        rows={listaTerapias}
                        onSelect={setTerapiaElegida}
                        onAceptar={elegirTerapia}
                    />

                    {/* Lupa del periodo del periodo de terapia. */}
                    <DialogoBusqueda
                        open={buscandoPeriodoForm}
                        onClose={() => setBuscandoPeriodoForm(false)}
                        titulo="Buscar Periodo"
                        columns={columnasPeriodosForm}
                        rows={listaPeriodosForm}
                        onSelect={setPeriodoElegidoForm}
                        onAceptar={elegirPeriodoForm}
                        ancho="sm"
                    />

                    {/* Lupa de la tarifa del periodo. */}
                    <DialogoBusqueda
                        open={buscandoTarifa}
                        onClose={() => setBuscandoTarifa(false)}
                        titulo="Buscar Tarifa"
                        columns={[
                            { field: 'descripcion', headerName: 'Descripcion', width: 240, sortable: false, headerAlign: 'left' },
                            { field: 'monto', headerName: 'Monto', width: 100, sortable: false, headerAlign: 'right', align: 'right' },
                        ]}
                        rows={listaTarifas}
                        onAceptar={elegirTarifa}
                        rowKey={(row) => row.idConceptoCobro || row.id}
                        ancho="sm"
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default Index;
